import React from 'react';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';

/**
 * @typedef {import('../../App.d.ts').ComponentHelpStageProps} ComponentHelpStageProps
 */
/**
 * @param {ComponentHelpStageProps} props
 * @returns {Element}
 * @constructor
 */

export default ({ image, text }) => (
  <Container
    standout
    customContainerClassName="dodo-component-help-stage-container"
    customContentClassName="dodo-component-help-stage-component-wrapper"
  >
    <div
      data-testid="help-stage"
      className="dodo-component-help-stage"
    >
      <div className="dodo-component-help-stage__text">
        <h2>{text.headline}</h2>
        <p>{text.description}</p>
      </div>
      <div className="dodo-component-help-stage__image">
        <img
          src={image.src}
          srcSet={image.srcSet?.join(',')}
          alt={image.alt ?? ''}
        />
      </div>
    </div>
  </Container>
);
